/** "1,234,567" — thousands grouping without the host locale (rules/01 §6 bans `toLocaleString`). */
export function formatCount(n: number): string {
  const sign = n < 0 ? "-" : "";
  const digits = String(Math.trunc(Math.abs(n)));
  return sign + digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * "₹1,499" / "₹1,499.50" from PAISE (ADR-0012: every amount on the wire is in minor units, because
 * rounding a currency twice is how money goes missing). Whole rupees drop the decimals; a non-INR
 * currency keeps its code rather than borrowing the rupee sign.
 */
export function formatMoney(amountPaise: number, currency = "INR"): string {
  const negative = amountPaise < 0;
  const minor = Math.abs(Math.round(amountPaise));
  const whole = formatCount(Math.trunc(minor / 100));
  const fraction = minor % 100;
  const amount = fraction === 0 ? whole : `${whole}.${String(fraction).padStart(2, "0")}`;
  const sign = negative ? "-" : "";
  return currency === "INR" ? `${sign}₹${amount}` : `${sign}${amount} ${currency}`;
}

/**
 * "10" / "12.5" from basis points (`percentBp` 1000 = 10 %; a discount rule travels as an integer for the
 * same reason money does, ADR-0015 addendum of 2026-10-04). No trailing ".0", so a rule of 10 % reads
 * "10% off" and not "10.0% off".
 */
export function formatPercentBp(percentBp: number): string {
  return String(Math.round(percentBp) / 100);
}

/** "1.2 kB", "3.4 MB" for file sizes on export rows; no host locale involved. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} kB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
